import { useEffect, useState } from 'react';
import { GetReportingManagers } from '../redux/lms/apiRoute';
import { getFullName } from '../utils/common_functions';

const useLeaveReqManager = () => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchReporting = async () => {
      setLoading(true);
      try {
        const response = await GetReportingManagers();
        if (response?.statusCode === 200) {
          const data = response?.data?.map((item) => ({
            label: getFullName(item?.first_name, item?.middle_name, item?.last_name),
            value: item.id
          }));
          setOptions(data);
        } else {
          setError(response.message || 'Failed to fetch data');
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchReporting();
  }, []);

  return { options, loading, error };
};

export default useLeaveReqManager;
